// API
import { put } from "../../../services/api";
// Ducks
import { hideSpinner, showSpinner } from "../../../services/spinner.ducks";
import { setProfile } from "../../../services/auth.ducks";
import {
  setErrorNotification,
  setNotification
} from "../../../components/SmartNotification/SmartNotification.ducks";

// eslint-disable-next-line import/prefer-default-export
export const changeProfile = (profile) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    const { data } = await dispatch(put(`/user`, profile));

    dispatch(setProfile(data));

    setNotification({
      messageTranslationKey: `modules.localization.register.authenticated.settings.authentication.profileUpdateSuccessfully`,
      titleTranslationKey: `modules.localization.register.authenticated.settings.authentication.success`,
      type: `success`
    });

    dispatch(hideSpinner());
  } catch (err) {
    let message;

    if (err.response && err.response.data && err.response.data.message) {
      switch (err.response.data.message) {
        case `users.post.error.candidate.notFound`:
          message = `modules.localization.register.authenticated.error.candidate.notFound`;
          break;
        case `users.post.error.client.notFound`:
          message = `modules.localization.register.authenticated.error.client.notFound`;
          break;

        default:
          message = `modules.localization.register.anonymous.smartNotifications.error.generic`;
          break;
      }
    }

    dispatch(
      setErrorNotification({
        messageTranslationKey: message,
        titleTranslationKey: `modules.localization.register.anonymous.smartNotifications.error.error`
      })
    );
    dispatch(hideSpinner());
  }
};
